import { Flex, IconFont, Text } from '@byecode/ui'
import type { OtherPlatformType } from '@lighthouse/shared'
import * as React from 'react'
import styled from 'styled-components'

import { otherPlatformNameMap } from './constant'
import { openInstallOtherPlatform } from './OtherPlatformEvent'

interface OtherPlatformFeatureEmptyProps {
    type: OtherPlatformType
}

const SCxContainer = styled.div`
    line-height: 22px;
    font-size: var(--font-size-normal);
    display: flex;
    flex-direction: column;
    gap: 6px;
    background-color: var(--color-gray-100);
    border-radius: 6px;
    padding: 8px 12px;
`

export const OtherPlatformFeatureEmpty: React.FunctionComponent<OtherPlatformFeatureEmptyProps> = ({ type }) => {
    return (
        <SCxContainer>
            <Text color="var(--color-black)">需要先安装“{otherPlatformNameMap[type]}”插件</Text>
            <Flex onClick={() => openInstallOtherPlatform(type)} alignItems="center" gap={4} style={{ cursor: 'pointer' }}>
                <Text color="var(--color-gray-400)">立即安装</Text>
                <IconFont color="var(--color-gray-400)" type="ArrowRightSmall" size={16} />
            </Flex>
        </SCxContainer>
    )
}
